"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { clientStorage } from "@/lib/client-utils"

// Дефолтная страница после входа: РПО — свой ЛК, остальные роли — ERP.
// AuthGuard дополнительно перехватывает РПО на любом ERP-маршруте.
export default function RootPage() {
  const router = useRouter()

  useEffect(() => {
    const storedUser = clientStorage.getItem("user")
    const accessLevel = storedUser ? (JSON.parse(storedUser)?.accessLevel as string | undefined) : undefined
    router.replace(accessLevel === "rpo" ? "/rpo" : "/projects")
  }, [router])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-dark"></div>
        </div>
      </div>
    </div>
  )
}
